import i18n from '../locales/i18n';

// Nomes de arquivo chegam crus do backend (sem markdown) - quem decide como
// exibi-los é o front. Reaproveita o mesmo destaque em negrito que o texto
// hardcoded antigo usava.
function formatFilenames(filenames) {
    return (filenames || []).map((name) => `**${name}**`).join(', ');
}

// T-i18n: erros de sistema (falha de skill/execução) vêm do backend como
// código + parâmetros (`{ error_code, error_params }`), nunca mais como texto
// pronto - a tradução acontece só aqui, no namespace `errors`. Mensagens
// antigas, já persistidas antes desta mudança, continuam chegando como string
// pura e são exibidas como estão (sem tradução retroativa).
export function translateBackendError(error) {
    if (!error) {
        return error;
    }
    if (typeof error === 'string') {
        return error;
    }
    if (typeof error === 'object' && error.error_code) {
        const { filenames, large_files: largeFiles, ...restParams } = error.error_params || {};
        const params = { ...restParams };
        if (filenames) {
            params.filenames = formatFilenames(filenames);
        }
        let text = i18n.t(error.error_code, { ns: 'errors', ...params });
        // Tarefa 3 (specs/i18n_erros_sistema/): a dica de tamanho de arquivo
        // (model_provider_timeout/model_generic_failure) só aparece quando o
        // backend mandou algum arquivo grande - o backend nunca manda a
        // frase pronta, só a lista crua (FR-007).
        if (largeFiles && largeFiles.length > 0) {
            text += ` ${i18n.t('model_large_files_hint', { ns: 'errors', filenames: formatFilenames(largeFiles) })}`;
        }
        return text;
    }
    return error;
}
